export interface ImportProcessData {
    enabled: boolean;
    data: Record<string, any>;
    failedMetadataErrorMessages: string[];
    registeredDataErrorMessages: string[];
    unRegisteredClusters: Record<string, any>[];
    addedClusters: AddedClusters[];
};

export interface AddedClusters {
    clusterName: string;
    machineIndex: number;
    variantIndex: number;
}

export const importProcessDataTemplate: ImportProcessData = {
    enabled: false,
    data: {},
    failedMetadataErrorMessages: [],
    registeredDataErrorMessages: [],
    unRegisteredClusters: [],
    addedClusters: []
};